import React from 'react';
import { BodyText, Button, Grid } from 'ui-toolkit/components';

const buttonText = (holdOpen?: boolean) => {
  return holdOpen ? 'Remove' : 'Issue Hold Open';
};

export const HoldOpenNavigationItems: React.FC<{
  holdOpen?: boolean;
  setShowChangeHoldOpenFormModal: (val: boolean) => void;
}> = ({ holdOpen, setShowChangeHoldOpenFormModal }) => (
  <Grid templateColumns={`${holdOpen ? '3' : '1'}fr 1fr`}>
    {holdOpen && <BodyText>Hold Open Issued.</BodyText>}
    <Button intent={'secondary'} onClick={() => setShowChangeHoldOpenFormModal(true)}>
      {buttonText(holdOpen)}
    </Button>
  </Grid>
);
